module.exports = __webpack_public_path__ + "img/004.15601dbb.jpg";